import {
  Card,
  FormHeader,
  FormNewDescription,
  FormSection,
  FormTitle,
  tv,
} from '@eluve/components';

const groupCardStyles = tv({
  base: 'overflow-hidden rounded-xl shadow-none',
  variants: {
    variant: {
      filled: 'border-0 bg-bg-secondary',
      outline: 'border border-border-primary bg-bg-primary',
    },
  },
  defaultVariants: {
    variant: 'filled',
  },
});

/**
 * Titled card grouping related settings rows.
 */
export const SettingsGroup = ({
  title,
  description,
  children,
  variant,
}: {
  title?: string;
  description?: React.ReactNode;
  children: React.ReactNode;
  /**
   * - `filled` (default): tinted card, no border; the standard look.
   * - `outline`: bordered card on the page background, for groups on busy
   *   or list-style pages where a border helps them read as a unit.
   */
  variant?: 'filled' | 'outline';
}) => (
  <FormSection className="gap-4">
    {(title ?? description) != null && (
      <FormHeader>
        {title != null && <FormTitle>{title}</FormTitle>}
        {description != null && (
          <FormNewDescription>{description}</FormNewDescription>
        )}
      </FormHeader>
    )}
    <Card className={groupCardStyles({ variant })}>{children}</Card>
  </FormSection>
);
